import { Divider } from '@mui/material'
import { FormFieldAutocomplete } from 'global/components/Form'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { centroCusto, empresas as empresas_api, local } from 'service/api'
import { useStore } from 'store'

export const Associacoes: React.FC = () => {
    const { watch, setValue } = useFormContext()
    const empresaId = useStore(state => state.companyId)
    const categoriaId = watch('Usuario.categoriaId')

    const { data: locaisData } = local.useFetch({
        queryParams: { empresaId },
    })
    const { data: centrosCustoData } = centroCusto.useFetch({
        queryParams: { empresaId },
    })
    const { data: empresasData } = empresas_api.useFetch()

    React.useEffect(() => {
        if (categoriaId && categoriaId == 3) {
            setValue('centroCustoIds', [])
            setValue('localIds', [])
            setValue('empresaIds', [])
        }
    }, [categoriaId])

    return categoriaId && categoriaId != 3 ? (
        <>
            <Divider className="mb-4">
                Associar empresa, centro de custo ou local
            </Divider>
            <FormFieldAutocomplete
                name="empresaIds"
                label="Empresas"
                options={empresasData ?? []}
                getOptionLabel={option => option.nomeFantasia}
                placeholder={'Selecione uma ou mais empresas'}
                multiple
                limitTags={2}
            />
            <FormFieldAutocomplete
                name="centroCustoIds"
                label="Centros de custo"
                options={centrosCustoData ?? []}
                getOptionLabel={option =>
                    option.nomeCentroCusto + ' - ' + option.codigo
                }
                placeholder={'Selecione um ou mais centros de custo'}
                multiple
                limitTags={2}
            />
            <FormFieldAutocomplete
                name="localIds"
                label="Locais"
                options={locaisData ?? []}
                getOptionLabel={option => option.nomeLocal}
                placeholder={'Selecione um ou mais locais'}
                multiple
                limitTags={2}
            />
        </>
    ) : null
}
